module.exports = __webpack_public_path__ + "media/images/icon__whatsapp-db15c4ade1f9319e14bbb51d8b0c5a10.png";